var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-text-box",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.value)},on:{"keydown":_vm.editText,"blur":_vm.outFocus}})}
var staticRenderFns = []

export { render, staticRenderFns }